/* eslint-disable @next/next/no-img-element */
import '../index.scss';
import './messageItem.scss';
import MenuOpts from './menuOpts';
import LineEllipsisSpan from './ellipsSpan';
import WhiteIcon from '../assets/white-icon.png';
import { imageUtil } from '@/utils/imageUtil';
import UKToast from '@/components/UKToast/index';
import PromotionWhiteIcon from '../assets/promotion-white.png';
import { MessageItem } from '@/apis/message/message.interface';
import { MessageTypeEnum, MessageSubTypeEnum } from '@/apis/message/message.interface';
import PriceDropIcon from '../assets/pricedrop-logo.svg';
import IntlDialog from '@/common-components-src/js/reviews/dialog';
import { useState } from 'react';
import { ReviewDetailItem } from '@/common-components-src/api/reviews/review.interface';
import ReveiwDetailList from '@/common-components-src/js/reviews/reviewDetailList';
import { sendClickTrack, EXPOSURE_RECORD } from '@/tracks/25630';
import { EXPCONFIG_FAST } from '@/constants/point';
import { useTranslation } from '@/i18n/client';
import AddEmailController from './addEmailController.js';
import { fetchOrderDetail } from '@/apis/order/order.api';
import { fetchUserReviewDetail } from '@/apis/dp/service';

interface ItemProps {
  params: any;
  type: number;
  item: MessageItem;
  userInfo?: any;
  onClose?: () => void;
  onDelete?: (msgId: string) => void;
}

interface PointProps {
  params: any;
  className: string;
  children: React.ReactNode;
  onClickItem?: (event: any) => void;
}

function PointWrapper({ className, params, children, onClickItem }: PointProps) {
  return (
    <div
      className={className}
      onClick={onClickItem}
      exptag={'exp|' + EXPOSURE_RECORD.Message_MsgDetail_MsgExpo}
      data-exptag-config={EXPCONFIG_FAST}
      data-exptag-json-param={JSON.stringify(params)}
    >
      {children}
    </div>
  );
}

export function CommonItem({ data }: { data: ItemProps }) {
  const { t } = useTranslation();

  const { item, params, type, onDelete } = data;
  const imgPath = item?.extraAttribute?.sImgPath;
  const msgType = item?.extraAttribute?.msgSubType;
  const { skuId, skuName }: any = item?.extraAttribute;
  const [skuID, setSkuID] = useState<string>(''); // 评价详情的skuId;
  const [isOpenReviewDetail, setIsOpenReviewDetail] = useState<boolean>(false); // 打开评价详情弹框
  const [reviewDetailData, setReviewDetailData] = useState<ReviewDetailItem | null>(null); // 评价详情数据

  const onDeleteDetailReply = (replyId: string) => {
    if (reviewDetailData && reviewDetailData.replyList) {
      const myReviewDetailData = { ...reviewDetailData };
      myReviewDetailData.replyList = reviewDetailData?.replyList?.filter(
        (item) => item.id !== replyId,
      );
      setReviewDetailData(myReviewDetailData);
    }
  };

  const onDeleteItem = () => {
    onDelete?.(item?.msgId);
    sendClickTrack.Message_MsgDetail_DeleteMsg(params);
  };

  const onClickItem = (event: any) => {
    if (isOpenReviewDetail) {
      return;
    }
    if (!event.target.closest('.MuiPopover-root')) {
      handleClick();
    }
  };

  const handleClick = () => {
    sendClickTrack.Message_MsgDetail_Msg(params);
    if (msgType) {
      switch (msgType) {
        case MessageSubTypeEnum.ORDER_PAY_COMPLETED:
        case MessageSubTypeEnum.ORDER_SHIPPED:
        case MessageSubTypeEnum.ORDER_COMPLETE:
        case MessageSubTypeEnum.ORDER_CANCEL:
        case MessageSubTypeEnum.ORDER_CANCEL_FAILED:
        case MessageSubTypeEnum.PRESALE_CANCEL_SUCCESS:
        case MessageSubTypeEnum.AFTERSALE_CANCEL_SUCCESS:
        case MessageSubTypeEnum.AFTERSALE_APPLY_SUCCESS:
        case MessageSubTypeEnum.AFTERSALE_APPLY_FAIL:
        case MessageSubTypeEnum.AFTERSALE_PICKUP_SUCCESS:
          gotoOrderDetail();
          break;
        case MessageSubTypeEnum.REVIRE:
          gotoReviewDetail();
          break;
        case MessageSubTypeEnum.ARRIVAL_NOTIFY:
          gotoProductDetail();
          break;
        default:
          gotoLandpage();
          break;
      }
    } else {
      switch (type) {
        case MessageTypeEnum.orders:
        case MessageTypeEnum.aftersale:
          gotoOrderDetail();
          break;
        case MessageTypeEnum.mentions:
          gotoReviewDetail();
          break;
        default:
          gotoLandpage();
          break;
      }
    }
  };

  const gotoOrderDetail = async () => {
    const asoId = item?.extraAttribute?.asoId;
    const orderId = item?.extraAttribute?.orderId || 0;
    const requestData = { orderId: String(orderId) };
    const orderDetailData = await fetchOrderDetail(requestData);
    if (orderDetailData?.orderStatusDTO?.recycle) {
      UKToast.show({
        content: t('order.orderDetail.deletedModal.modalContent'),
        icon: 'warning',
      });
    } else if (asoId) {
      location.href = `/my-orders/refund?afsServiceId=${asoId}&orderId=${orderId}`;
    } else {
      location.href = '/profile/my-orders/order-details?orderId=' + orderId.toString();
    }
  };

  const gotoReviewDetail = async () => {
    const attribute = item?.extraAttribute;
    if (attribute && !!attribute.skuId && !!attribute.commentId) {
      const params = {
        skuId: attribute.skuId,
        commentId: attribute.commentId,
        parentReplyId: attribute.parentReplyId || 0,
      };
      const res = await fetchUserReviewDetail(params);
      if (res && res.code === '200') {
        setSkuID(params.skuId);
        // @ts-ignore
        setReviewDetailData(res.data || null);
        setIsOpenReviewDetail(true);
      } else {
        UKToast.show({
          // @ts-ignore
          content: res?.msg,
          icon: 'warning',
        });
      }
    }
  };

  const gotoProductDetail = () => {
    if (skuId) {
      location.href = skuName ? `/dp/${skuName}/${skuId}` : `/dp/${skuId}`;
    }
  };

  const gotoLandpage = () => {
    if (item && item.extraAttribute && item.extraAttribute.landPageUrlForM) {
      window.location.href = item.extraAttribute.landPageUrlForM;
    }
  };

  return (
    <PointWrapper className='common cursor' key={type} onClickItem={onClickItem} params={params}>
      <div className='date'>{item.formatTime}</div>
      <div className='frame'>
        <div className='header'>
          <div className='title'>{item.title}</div>
          <MenuOpts onDelete={onDeleteItem} />
        </div>
        <div className='content'>
          {imgPath && (
            <img
              src={imageUtil.concatImgUrlWithoutForceHttps(imgPath)}
              alt={type.toString()}
              onError={(e: any) => {
                e.target.src = WhiteIcon;
              }}
            />
          )}
          {msgType === MessageSubTypeEnum.ACCOUNT ? (
            <span>{item.content}</span>
          ) : (
            <LineEllipsisSpan content={item.content} endStr={t('messages.toView')} />
          )}
        </div>
      </div>
      <IntlDialog
        width={800}
        title='Review'
        open={isOpenReviewDetail}
        onClose={() => setIsOpenReviewDetail(false)}
        sx={{ zIndex: 2300 }}
        content={
          <ReveiwDetailList
            skuId={skuID}
            lists={reviewDetailData ? [reviewDetailData] : []}
            onClose={() => setIsOpenReviewDetail(false)}
            onDeleteDetailReply={onDeleteDetailReply}
          />
        }
      />
    </PointWrapper>
  );
}

export function PriceDropItem({ data }: { data: ItemProps }) {
  const { item, params, type, onDelete } = data;
  const { sImgPath, icon, tipHtml, skuId, skuName }: any = item?.extraAttribute;

  const onDeleteItem = () => {
    onDelete?.(item?.msgId);
    sendClickTrack.Message_MsgDetail_DeleteMsg(params);
  };

  const onClickItem = (event: any) => {
    if (!event.target.closest('.MuiPopover-root')) {
      location.href = skuName ? `/dp/${skuName}/${skuId}` : `/dp/${skuId}`;
      sendClickTrack.Message_MsgDetail_Msg(params);
    }
  };

  return (
    <PointWrapper className='pricedrop cursor' key={type} onClickItem={onClickItem} params={params}>
      <div className='date'>{item.formatTime}</div>
      <div className='frame'>
        <div className='header'>
          <div className='title'>{item.title}</div>
          <MenuOpts onDelete={onDeleteItem} />
        </div>
        <div className='content'>
          {sImgPath && (
            <img
              src={imageUtil.concatImgUrlWithoutForceHttps(sImgPath)}
              alt={type.toString()}
              onError={(e: any) => {
                e.target.src = WhiteIcon;
              }}
            />
          )}
          <div className='content-frame'>
            <div className='sku-name'>{item.content}</div>
            <div className='price-drop'>
              <img
                alt={'pricedrop' + type.toString()}
                src={icon ? imageUtil.concatImgUrlWithoutForceHttps(icon) : PriceDropIcon}
              />
              <span dangerouslySetInnerHTML={{ __html: tipHtml }} />
            </div>
          </div>
        </div>
      </div>
    </PointWrapper>
  );
}

export function CampaignItem({ data }: { data: ItemProps }) {
  const { item, params, type, onDelete } = data;

  const onDeleteItem = () => {
    onDelete?.(item?.msgId);
    sendClickTrack.Message_MsgDetail_DeleteMsg(params);
  };

  const onClickItem = (event: any) => {
    if (!event.target.closest('.MuiPopover-root')) {
      if (item?.extraAttribute?.landPageUrlForM) {
        window.location.href = item.extraAttribute.landPageUrlForM;
      }
      sendClickTrack.Message_MsgDetail_Msg(params);
    }
  };

  return (
    <PointWrapper className='promotion cursor' key={type} onClickItem={onClickItem} params={params}>
      <div className='date'>{item.formatTime}</div>
      <div className='content'>
        <div className='promotion-title'>
          <span>{item.title}</span>
          <MenuOpts onDelete={onDeleteItem} />
        </div>
        {!!item.content && <em>{item.content}</em>}
        <img
          alt={type.toString()}
          onError={(e: any) => {
            e.target.src = PromotionWhiteIcon;
          }}
          src={imageUtil.concatImgUrlWithoutForceHttps(item?.extraAttribute?.sImgPath as string)}
        />
      </div>
    </PointWrapper>
  );
}

export function JumpBtnItem({ data }: { data: ItemProps }) {
  const { t } = useTranslation();
  const { item, params, type, userInfo, onClose, onDelete } = data;
  const msgType = item?.extraAttribute?.msgSubType;

  const onDeleteItem = () => {
    onDelete?.(item?.msgId);
    sendClickTrack.Message_MsgDetail_DeleteMsg(params);
  };

  const onClickItem = (event: any) => {
    if (!event.target.closest('.MuiPopover-root')) {
      handleClick();
    }
  };

  const handleClick = () => {
    sendClickTrack.Message_MsgDetail_Msg(params);
    switch (msgType) {
      case MessageSubTypeEnum.EMAIL:
        jumpToEmail();
        break;
    }
  };

  const jumpToEmail = () => {
    if (userInfo && userInfo.email) {
      UKToast.show({
        content: t('messages.emailAdded'),
        icon: 'warning',
      });
    } else {
      onClose && onClose();
      AddEmailController.getInstance().openAddEmailDialog();
    }
  };

  return (
    <PointWrapper className='jump' key={type} params={params}>
      <div className='date'>{item.formatTime}</div>
      <div className='frame'>
        <div className='header'>
          <div className='title'>{item.title}</div>
          <MenuOpts onDelete={onDeleteItem} />
        </div>
        <div className='content'>
          <div className='img-text'>
            <span>{item.content}</span>
          </div>
        </div>
        <div className='btnBox'>
          <button onClick={onClickItem}>{t('messages.bindNow')}</button>
        </div>
      </div>
    </PointWrapper>
  );
}
